// frontend/src/pages/PartitionManagement.js
import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Spinner, Row, Col, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { toast } from 'react-toastify';

const PartitionManagement = () => {
    const [partitions, setPartitions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [partitionToDelete, setPartitionToDelete] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    // 新增：选中分区及其设备状态
    const [selectedPartition, setSelectedPartition] = useState(null);
    const [partitionDevices, setPartitionDevices] = useState([]);
    const [devicesLoading, setDevicesLoading] = useState(false);
    // 新增：添加/编辑分区状态
    const [showAddModal, setShowAddModal] = useState(false);
    const [newPartitionName, setNewPartitionName] = useState('');
    const [newPartitionDesc, setNewPartitionDesc] = useState('');
    const [newPartitionFile, setNewPartitionFile] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editPartition, setEditPartition] = useState(null);    const [editPartitionName, setEditPartitionName] = useState('');
    const [editPartitionDesc, setEditPartitionDesc] = useState('');
    const [editPartitionFile, setEditPartitionFile] = useState(null);
    // 新增：分区账目状态
    const [showLedgerModal, setShowLedgerModal] = useState(false);
    const [selectedPartitionLedger, setSelectedPartitionLedger] = useState(null);
    const [partitionLedgerData, setPartitionLedgerData] = useState(null);
    const [ledgerLoading, setLedgerLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        fetchPartitions();
    }, []);

    const fetchPartitions = async () => {
        setLoading(true);
        try {
            const res = await api.get('/api/partitions');
            setPartitions(res.data);
        } catch (error) {
            console.error('获取分区列表失败:', error);
            toast.error(error.response?.data?.message || '获取分区列表失败');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (partition) => {
        setPartitionToDelete(partition);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (!partitionToDelete) return;
        try {
            await api.delete(`/api/partitions/${partitionToDelete._id}`);
            toast.success('分区删除成功');
            setPartitions(partitions.filter(p => p._id !== partitionToDelete._id));
        } catch (error) {
            console.error('删除分区失败:', error);
            toast.error(error.response?.data?.message || '删除分区失败');
        } finally {
            setShowDeleteModal(false);
            setPartitionToDelete(null);
        }
    };

    const cancelDelete = () => {
        setShowDeleteModal(false);
        setPartitionToDelete(null);
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        try {
            const res = await api.get(`/api/partitions?search=${searchTerm}`);
            setPartitions(res.data);
        } catch (error) {
            console.error('搜索分区失败:', error);
            toast.error(error.response?.data?.message || '搜索分区失败');
        }
    };

    const handleReset = () => {
        setSearchTerm('');
        fetchPartitions();
    };

    // 打开添加分区弹窗
    const openAddModal = () => {
      setNewPartitionName(''); setNewPartitionDesc('');
      setNewPartitionFile(null);
      setShowAddModal(true);
    };
    const closeAddModal = () => setShowAddModal(false);
    const handleAddPartition = async () => {
      if (!newPartitionName.trim()) return toast.warn('分区名称不能为空');
      try {
        const res = await api.post('/api/partitions', { name: newPartitionName.trim(), description: newPartitionDesc.trim() });
        const id = res.data._id;
        if (newPartitionFile) {
          const fd = new FormData(); fd.append('cover', newPartitionFile);
          await api.post(`/api/partitions/${id}/cover`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        toast.success('分区添加成功'); fetchPartitions(); closeAddModal();
      } catch (err) { toast.error(err.response?.data?.message || '添加分区失败'); }
    };
    // 打开编辑分区弹窗
    const openEditPartitionModal = (p) => {
      setEditPartition(p); setEditPartitionName(p.name); setEditPartitionDesc(p.description || '');
      setEditPartitionFile(null);
      setShowEditModal(true);
    };
    const closeEditModal = () => setShowEditModal(false);
    const handleEditPartition = async () => {
      if (!editPartitionName.trim()) return toast.warn('分区名称不能为空');
      try {
        await api.put(`/api/partitions/${editPartition._id}`, { name: editPartitionName.trim(), description: editPartitionDesc.trim() });
        if (editPartitionFile) {
          const fd = new FormData(); fd.append('cover', editPartitionFile);
          await api.post(`/api/partitions/${editPartition._id}/cover`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        toast.success('分区更新成功'); fetchPartitions(); closeEditModal();
      } catch (err) { toast.error(err.response?.data?.message || '更新分区失败'); }
    };
      /** 获取指定分区下的设备列表 */
    const openPartitionDevices = async (partition) => {
      setSelectedPartition(partition);
      setDevicesLoading(true);
      try {
        const res = await api.get(`/api/partitions/${partition._id}/devices`);
        setPartitionDevices(res.data.devices || []);
      } catch (error) {
        console.error('获取分区设备失败:', error);
        toast.error(error.response?.data?.message || '获取分区设备失败');
      } finally {
        setDevicesLoading(false);
      }
    };

    /** 获取分区账目统计 */
    const openPartitionLedger = async (partition) => {
      setSelectedPartitionLedger(partition);
      setLedgerLoading(true);
      setShowLedgerModal(true);
      try {
        const res = await api.get(`/api/partitions/${partition._id}/ledger`);
        setPartitionLedgerData(res.data);
      } catch (error) {
        console.error('获取分区账目失败:', error);
        toast.error(error.response?.data?.message || '获取分区账目失败');
      } finally {
        setLedgerLoading(false);
      }
    };

    const closeLedgerModal = () => {
      setShowLedgerModal(false);
      setSelectedPartitionLedger(null);
      setPartitionLedgerData(null);
    };

    return (
        <div>
            <h2 className="mt-4">分区管理</h2>
            <Row className="mb-3">
                <Col md={4}>
                    <Button variant="primary" onClick={openAddModal}>添加分区</Button>
                </Col>
                <Col md={8}>
                    <Form onSubmit={handleSearch}>
                        <Row>
                            <Col md={10}>
                                <Form.Control
                                    type="text"
                                    placeholder="搜索分区名称"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </Col>
                            <Col md={2}>
                                <Button variant="outline-success" type="submit">搜索</Button>
                                <Button variant="outline-secondary" className="ms-2" onClick={handleReset}>重置</Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
            {loading ? (
                <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">加载中...</span>
                    </Spinner>
                </div>
            ) : (
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                  <th>封面</th>
                  <th>分区名称</th>
                  <th>描述</th>
                  <th>创建时间</th>
                  <th>更新时间</th>
                  <th>操作</th>
              </tr>
          </thead>
          <tbody>
              {partitions.length > 0 ? (
                  partitions.map(partition => (
                      <tr key={partition._id}>
                        <td style={{ width: 80, textAlign: 'center' }}>
                          {partition.coverPath ? (
                            <img
                              src={`${api.defaults.baseURL}/uploads/${partition.coverPath}`}
                              alt="封面"
                              style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }}
                            />
                          ) : (
                            '—'
                          )}
                        </td>
                          <td>{partition.name}</td>
                          <td>{partition.description || '无'}</td>
                          <td>{new Date(partition.createdAt).toLocaleString()}</td>
                          <td>{new Date(partition.updatedAt).toLocaleString()}</td>                          <td>
                              <Button variant="info" size="sm" onClick={() => openPartitionDevices(partition)}>查看设备</Button>{' '}
                              <Button variant="success" size="sm" onClick={() => openPartitionLedger(partition)}>分区账目</Button>{' '}
                              <Button variant="warning" size="sm" onClick={() => openEditPartitionModal(partition)}>编辑</Button>{' '}
                              <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => handleDelete(partition)}
                              >
                                  删除
                              </Button>
                          </td>
                      </tr>
                  ))
              ) : (
                  <tr>
                      <td colSpan="6" className="text-center">
                          暂无分区数据
                      </td>
                  </tr>
              )}
          </tbody>
      </Table>
            )}

            {/* 选中分区的设备列表 */}
            {selectedPartition && (
                <div className="mt-4">
                    <Row className="align-items-center mb-2">
                        <Col><h4>分区 {selectedPartition.name} 设备列表</h4></Col>
                        <Col className="text-end"><Button variant="secondary" onClick={() => setSelectedPartition(null)}>返回分区列表</Button></Col>
                    </Row>
                    {devicesLoading ? (
                        <div className="text-center"><Spinner animation="border" /></div>
                    ) : (
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>设备名称</th>
                                    <th>设备ID</th>
                                    <th>状态</th>
                                    <th>占用者</th>
                                </tr>
                            </thead>
                            <tbody>
                                {partitionDevices.length > 0 ? (
                                    partitionDevices.map(dev => (
                                        <tr key={dev._id}>
                                            <td>{dev.name}</td>
                                            <td>{dev._id.slice(-6)}</td>
                                            <td>{dev.status}</td>
                                            <td>{dev.currentHolder?.username || '—'}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">该分区暂无设备</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                </div>
            )}

            {/* 删除确认模态框 */}
            <Modal show={showDeleteModal} onHide={cancelDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>确认删除</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {partitionToDelete && (
                        <p>确定要删除分区 <strong>{partitionToDelete.name}</strong> 吗？此操作无法撤销。</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelDelete}>
                        取消
                    </Button>
                    <Button variant="danger" onClick={confirmDelete}>
                        删除
                    </Button>
                </Modal.Footer>
            </Modal>

             {/* 添加分区 Modal */}
     <Modal show={showAddModal} onHide={closeAddModal}>
       <Modal.Header closeButton><Modal.Title>添加分区</Modal.Title></Modal.Header>
       <Modal.Body>
         <Form>
           <Form.Group className="mb-3">
             <Form.Label>分区名称</Form.Label>
             <Form.Control value={newPartitionName} onChange={e => setNewPartitionName(e.target.value)} placeholder="请输入分区名称" />
           </Form.Group>
           <Form.Group className="mb-3">
             <Form.Label>分区描述</Form.Label>
             <Form.Control value={newPartitionDesc} onChange={e => setNewPartitionDesc(e.target.value)} placeholder="可选：分区描述" />
           </Form.Group>
+    <Form.Group className="mb-3">
+      <Form.Label>分区封面</Form.Label>
+      <Form.Control type="file" accept="image/*" onChange={e => setNewPartitionFile(e.target.files[0])} />
+    </Form.Group>
         </Form>
       </Modal.Body>
       <Modal.Footer>
         <Button variant="secondary" onClick={closeAddModal}>取消</Button>
         <Button variant="primary" onClick={handleAddPartition}>保存</Button>
       </Modal.Footer>
     </Modal>
     {/* 编辑分区 Modal */}
     <Modal show={showEditModal} onHide={closeEditModal}>
       <Modal.Header closeButton><Modal.Title>编辑分区</Modal.Title></Modal.Header>
       <Modal.Body>
         <Form>
           <Form.Group className="mb-3">
             <Form.Label>分区名称</Form.Label>
             <Form.Control value={editPartitionName} onChange={e => setEditPartitionName(e.target.value)} placeholder="请输入分区名称" />
           </Form.Group>
           <Form.Group className="mb-3">
             <Form.Label>分区描述</Form.Label>
             <Form.Control value={editPartitionDesc} onChange={e => setEditPartitionDesc(e.target.value)} placeholder="可选：分区描述" />
           </Form.Group>
+      <Form.Group className="mb-3">
+        <Form.Label>分区封面</Form.Label>
+        <Form.Control type="file" accept="image/*" onChange={e => setEditPartitionFile(e.target.files[0])} />
+      </Form.Group>
         </Form>
       </Modal.Body>
       <Modal.Footer>
         <Button variant="secondary" onClick={closeEditModal}>取消</Button>
         <Button variant="primary" onClick={handleEditPartition}>保存</Button>       </Modal.Footer>
     </Modal>

            {/* 分区账目统计模态框 */}
            <Modal show={showLedgerModal} onHide={closeLedgerModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedPartitionLedger ? `${selectedPartitionLedger.name} - 分区账目` : '分区账目'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {ledgerLoading ? (
                        <div className="text-center p-4">
                            <Spinner animation="border" />
                            <p className="mt-2">正在加载账目数据...</p>
                        </div>
                    ) : partitionLedgerData ? (
                        <div>
                            {/* 总体统计 */}
                            <div className="mb-4">
                                <h5>总体统计</h5>
                                <Row>                                    <Col md={3}>
                                        <div className="bg-primary text-white p-3 rounded text-center">
                                            <h6>玩家投注总额</h6>
                                            <h4>¥{partitionLedgerData.summary.totalBetAmount.toLocaleString()}</h4>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="bg-info text-white p-3 rounded text-center">
                                            <h6>玩家获得总额</h6>
                                            <h4>¥{partitionLedgerData.summary.totalPayoutAmount.toLocaleString()}</h4>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className={`p-3 rounded text-center text-white ${
                                            partitionLedgerData.summary.totalNetProfit >= 0 ? 'bg-success' : 'bg-danger'
                                        }`}>
                                            <h6>机器净盈利</h6>
                                            <h4>¥{partitionLedgerData.summary.totalNetProfit.toLocaleString()}</h4>
                                            <small>(投注-返还)</small>
                                        </div>
                                    </Col>
                                    <Col md={3}>
                                        <div className="bg-secondary text-white p-3 rounded text-center">
                                            <h6>总轮次</h6>
                                            <h4>{partitionLedgerData.summary.totalRounds}</h4>
                                        </div>
                                    </Col>
                                </Row>
                            </div>

                            {/* 设备详细统计 */}
                            <div>
                                <h5>设备账目明细</h5>
                                {partitionLedgerData.deviceStats.length > 0 ? (
                                    <Table striped bordered hover responsive>                                        <thead>
                                            <tr>
                                                <th>设备名称</th>
                                                <th>玩家投注</th>
                                                <th>玩家获得</th>
                                                <th>机器盈利</th>
                                                <th>轮次数</th>
                                                <th>盈利率</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {partitionLedgerData.deviceStats.map(device => (
                                                <tr key={device.deviceId}>
                                                    <td>{device.deviceName}</td>
                                                    <td>¥{device.betTotal.toLocaleString()}</td>
                                                    <td>¥{device.payoutTotal.toLocaleString()}</td>
                                                    <td className={device.netProfit >= 0 ? 'text-success' : 'text-danger'}>
                                                        ¥{device.netProfit.toLocaleString()}
                                                    </td>
                                                    <td>{device.roundCount}</td>
                                                    <td className={device.netProfit >= 0 ? 'text-success' : 'text-danger'}>
                                                        {device.betTotal > 0 
                                                            ? `${((device.netProfit / device.betTotal) * 100).toFixed(2)}%`
                                                            : '0.00%'
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div className="text-center p-4">
                                        <p className="text-muted">该分区暂无设备或账目数据</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div className="text-center p-4">
                            <p className="text-muted">暂无账目数据</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeLedgerModal}>
                        关闭
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default PartitionManagement;
